function TicketingSettingsModal({
  children,
  className = "",
  description,
  eyebrow,
  labelledBy,
  onClose,
  t,
  title,
}) {
  return (
    <div className="ticketingSettingsModalOverlay" role="presentation" onMouseDown={onClose}>
      <div
        className={`ticketingSettingsModal ${className}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="ticketingSettingsModalHeader">
          <div>
            <p>{eyebrow}</p>
            <h2 id={labelledBy}>{title}</h2>
            <span>{description}</span>
          </div>
          <button type="button" onClick={onClose} aria-label={t("closeModal")}>
            ×
          </button>
        </div>

        {children}
      </div>
    </div>
  );
}

export default TicketingSettingsModal;
